export default __webpack_public_path__ + "static/fair-payment-gold-logo-4df16d81aa2cf85587024160c7466d27.png";